<div
  class="form-horizontal"
  style="
   height: 52px;
   border: 1px solid #aaa;
   border-radius: 5px;
   margin-top: 10px;
   margin-bottom: 10px;
   display: flex;
  "
>
  <div
    class="input-group"
    style="padding: 8px; width: 40%; min-width: 420px"
    *ngIf="
      selectedIndex !== undefined && selectedIndex !== null && !isOnlyPreview
    "
  >
    <p-dropdown
      [options]="displayTemplateParameters"
      [(ngModel)]="selectedTemplateParameter"
      styleClass="form-control insert-parameter-dropdown"
    >
      <ng-template let-item pTemplate="item">
          <div *ngIf="item.label.indexOf('hr') === -1">{{item.label}}</div>
          <div *ngIf="item.label.indexOf('hr') !== -1"><hr/></div>
      </ng-template>
    </p-dropdown>
    <button
      class="btn btn-primary border-left-flat"
      style="height: 36px; min-width: 160px"
      (click)="
        contenteditableDirective.addParameter(
          selection,
          templateParameters,
          selectedTemplateParameter,
          selectedNode
        )
      "
      tooltip="This will be replaced at the time of sending the message"
    >
      Insert parameter
    </button>
  </div>
</div>

<label>Subject: </label>
<div *ngIf="templateUpdateModel$ | async">
  <div class="emailSubject">
    <div cleanVariableContentAfterPaste modelVariableName="emailSubject" >
      <div
        *ngIf="template !== undefined"
        #emailSubject
        style="
          width: 100%;
          overflow: hidden;
          overflow-x: auto;
          white-space: nowrap;
          outline: none;
          box-shadow: none;
          border: 1px solid #aaa;
          border-radius: 5px;
          padding: 7px;
          height: 36px;
        "
        [attr.contenteditable]="!isOnlyPreview"
        contenteditable
        strip-nbsp="true"
        strip-newLine="true"
        id="template.emailSubject"
        [ng-model]="'emailSubject'"
        (click)="setSelectedIndex($event, 1)"
        (blur)="setSelectedData()"
        [innerHtml]="template.emailSubject || '' | safe: 'html'"
        [disablePasteEvent]="'true'"
      ></div>
    </div>
  </div>
  <br />
  <div
    class="coll-md-12 text-center"
    *ngIf="mailContent === undefined || template === undefined; else templatecontent"
  >
    <img src="img/loading.gif" />
  </div>

  <ng-template #templatecontent>
    <div style="border-style: inset">
      <ng-template
        [featureFlags]="['communication:editor:tmp']"
        [featureFlagsElse]="without_editor"
      >
        <ng-editor [isDisable]="isOnlyPreview || false" [templateUpdateModel]="templateUpdateModel">
          <div
            uploadImage
            [uploadImageDisable]="isOnlyPreview"
            contenteditable="false"
            (focusout)="onFocusOut($event)"
            style="overflow-x: auto; outline: none; min-height: 300px"
            (click)="setSelectedIndex($event, 2)"
            [innerHtml]="mailContent || '' | safe: 'html'"
            *ngIf="mailContent"
          ></div>
        </ng-editor>
      </ng-template>
      <ng-template #without_editor>
        <div
          uploadImage
          [uploadImageDisable]="isOnlyPreview"
          contenteditable="false"
          (focusout)="onFocusOut($event)"
          style="overflow-x: auto; outline: none; min-height: 300px"
          (click)="setSelectedIndex($event, 2)"
          [innerHtml]="mailContent || '' | safe: 'html'"
          *ngIf="mailContent"
        ></div>
      </ng-template>
    </div>
  </ng-template>
</div>
